<!-- eslint-disable vue/no-v-html -->
<template>
  <span
    class="help-center-icon__component"
    :style="componentStyles"
    :data-name="name"
    aria-hidden="true"
    v-html="uniqHTML"
  />
</template>

<script setup>
import { computed } from 'vue'
import { uniqueId } from 'gleam-shared/helpers/nodash'
import camelCase from 'gleam-shared/helpers/camelCase'
import ICONS from 'help-center/constants/icons'

const props = defineProps({
  name: {
    type: String,
    required: true
  },
  sizeUnits: {
    type: [Number, String],
    required: true
  }
})

const iconHTML = computed(() => {
  const normalizedName = camelCase(props.name)
  const icon = ICONS[normalizedName]

  if (icon) {
    return icon
  } else {
    console.warn(`HelpCenterIcon: ${props.name} is missing!`)
    return ICONS.statusFailed
  }
})

const uniqHTML = computed(() => {
  // "display: none" applied to one SVG using a gradient,
  // will make all SVGs using the same gradient disappear
  const ids = iconHTML.value.match(/(?<=id=").+?(?=")/g)

  if (ids) {
    const cache = {}
    return ids.reduce((html, id) => {
      return html.replaceAll(id, (id) => {
        return cache[id] ||= uniqueId(id)
      })
    }, iconHTML.value)
  } else {
    return iconHTML.value
  }
})

const componentStyles = computed(() => {
  return {
    '--size-units': props.sizeUnits
  }
})
</script>

<style lang="scss">
.help-center-icon {
  &__component {
    --size: calc(var(--size-units) * 4px);
    width: var(--size, 1em);
    height: var(--size, 1em);
    display: inline-flex;
    vertical-align: middle;
  }
}
</style>
